import { useMemo } from "react";
import {
  useGetListCityPostOffice,
  useGetListDistrictPostOffice,
  useGetListProvince,
} from "service/query/common.query";

/** Hook trả về list bưu điện tỉnh thành phố, bưu điện huyện, bưu cục*/
export const useCityDistrictProvince = (options = {}) => {
  const { citycode, districtcode, optionsGetDistrict, optionsGetProvince } =
    options;
  const { data: listCityPostOffice } = useGetListCityPostOffice();

  const { data: listDistrictPostOffice } = useGetListDistrictPostOffice(
    {
      filter: { where: { citycode } },
    },
    {
      enabled: !!citycode,
      ...optionsGetDistrict,
    }
  );

  const { data: listProvince } = useGetListProvince(
    {
      filter: {
        where: {
          ...(citycode && !districtcode && { citycode }),
          ...(districtcode && { districtcode }),
        },
      },
    },
    {
      enabled: !!citycode && !!districtcode,
      ...optionsGetProvince,
    }
  );

  const listCityPostOfficeOptions = useMemo(
    () =>
      listCityPostOffice?.map((item) => ({
        value: item.code,
        label: `${item.code} - ${item.name}`,
      })),
    [listCityPostOffice]
  );

  const listDistrictPostOfficeOptions = useMemo(
    () =>
      listDistrictPostOffice?.map((item) => ({
        value: item.code,
        label: item.name,
      })),
    [listDistrictPostOffice]
  );

  const listProvinceOptions = useMemo(
    () =>
      listProvince?.map((item) => ({
        value: item.code,
        label: item.name,
      })),
    [listProvince]
  );

  return {
    listCityPostOffice,
    listDistrictPostOffice,
    listProvince,
    listCityPostOfficeOptions,
    listDistrictPostOfficeOptions,
    listProvinceOptions,
  };
};
